/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminGetClientReviewsApiResponse } from '../models/AdminGetClientReviewsApiResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminClientManagementService {
    /**
     * Fetch clients
     * Retrieve a paginated list of clients with search, filters, and sorting. Filters accept comma-separated values for serviceType, accountStatus, and location.
     * @param search Search by name, email, or phone (partial, case-insensitive)
     * @param serviceType Filter by service type slugs (comma-separated)
     * @param accountStatus Filter by account status (comma-separated: active, inactive, suspended)
     * @param location Filter by location city/state (comma-separated)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page (max 100)
     * @param sortBy Sort by field
     * @param sortOrder Sort order
     * @returns any Clients fetched successfully
     * @throws ApiError
     */
    public static adminClientsControllerFetchClientsV1(
        search?: string,
        serviceType?: string,
        accountStatus?: string,
        location?: string,
        page: number = 1,
        pageSize: number = 10,
        sortBy: 'full_name' | 'date_of_birth' | 'total_sessions' | 'total_bookings' | 'created_at' = 'created_at',
        sortOrder: 'asc' | 'desc' = 'desc',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/clients',
            query: {
                'search': search,
                'serviceType': serviceType,
                'accountStatus': accountStatus,
                'location': location,
                'page': page,
                'pageSize': pageSize,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
            },
        });
    }
    /**
     * Get unique client locations
     * Returns distinct city and state values from client user locations for filter options.
     * @returns any List of { label, value } location options
     * @throws ApiError
     */
    public static adminClientsControllerGetUniqueClientLocationsV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/clients/locations',
        });
    }
    /**
     * Get client detail
     * Get full client profile including stats, BMI, preferences, and suspension details.
     * @param id Client ID (UUID from clients table)
     * @returns any Client detail retrieved
     * @throws ApiError
     */
    public static adminClientsControllerGetClientDetailV1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/clients/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid UUID format`,
                404: `Client not found`,
            },
        });
    }
    /**
     * Get client bookings
     * Retrieve paginated list of a client's bookings with optional status filter.
     * @param id Client ID (UUID from clients table)
     * @param status Filter by status (comma-separated: pending, active, completed, cancelled)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page (max 100)
     * @returns any Bookings retrieved
     * @throws ApiError
     */
    public static adminClientsControllerGetClientBookingsV1(
        id: string,
        status?: string,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/clients/{id}/bookings',
            path: {
                'id': id,
            },
            query: {
                'status': status,
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                404: `Client not found`,
            },
        });
    }
    /**
     * Get client session notes & feedback
     * Retrieve session notes and diet plans for a client.
     * @param id Client ID (UUID from clients table)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns any Notes retrieved
     * @throws ApiError
     */
    public static adminClientsControllerGetClientNotesV1(
        id: string,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/clients/{id}/notes',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                404: `Client not found`,
            },
        });
    }
    /**
     * Get client reviews
     * Retrieve paginated list of reviews submitted by a client.
     * @param id Client ID (UUID from clients table)
     * @param page Page number (1-indexed)
     * @param pageSize Items per page
     * @returns AdminGetClientReviewsApiResponse Reviews retrieved
     * @throws ApiError
     */
    public static adminClientsControllerGetClientReviewsV1(
        id: string,
        page: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<AdminGetClientReviewsApiResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/clients/{id}/reviews',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'pageSize': pageSize,
            },
            errors: {
                404: `Client not found`,
            },
        });
    }
}
